import React from 'react';
import { CoreModal } from '@komodo-design-system/komodo-components-react';
import './AlertBox.scss';

interface AlertBoxProps {
  message: string;
  isModalOpen: boolean;
  handleClose: () => void;
  header?: boolean;
  bgClose?: boolean;

}

function AlertBox(props: AlertBoxProps) {
  const {
    message,
    isModalOpen,
    handleClose,
    header = true,
    bgClose = false
  } = props;
  return (
    <div data-testid="alert-box" className="alert-boxv2">
      <CoreModal
        className="alert-box-modal"
        data-testid="alert-box-modal"
        isopen={isModalOpen}
        onModalClosedTrigger={handleClose}
        bgclose={bgClose}
        closeicon={true}
        header={header ? 'Message' : ''}
        buttons={JSON.stringify([{ variant: 'primary', label: 'OK', action: 'close', customAction: handleClose }])}
        zindex={1000}>
        {/* Render the message as HTML */}
        <div
          style={{ fontSize: '16px', fontWeight: '500' }}
          dangerouslySetInnerHTML={{ __html: message }}
        />      </CoreModal>
    </div>
  );
}

export default AlertBox;


